import { Base } from '@studiometa/js-toolkit';
import { nextTick } from '@studiometa/js-toolkit/utils';

/**
 * Parcours class.
 */
export default class Parcours extends Base {
  /**
   * Class cofnig
   * @type {object}
   */
  static config = {
    name: 'Parcours',
    refs: ['btnVtt', 'btnRoute', 'containerVTT', 'containerRoute'],
  };

  onBtnVttClick() {
    this.$refs.containerVTT.classList.remove('hidden');
    this.$refs.containerRoute.classList.add('hidden');
    this.$refs.btnVtt.classList.add('btn--orange');
    this.$refs.btnVtt.classList.remove('btn--white');
    this.$refs.btnRoute.classList.remove('btn--orange');
    this.$refs.btnRoute.classList.add('border-orange', 'btn--white');

    setTimeout(() => {
      this.$root.$update();
      window.dispatchEvent(new Event('resize'));
    }, 1000);
  }

  onBtnRouteClick() {
    this.$refs.containerVTT.classList.add('hidden');
    this.$refs.containerRoute.classList.remove('hidden');
    this.$refs.btnVtt.classList.remove('btn--orange');
    this.$refs.btnVtt.classList.add('border-orange', 'btn--white');
    this.$refs.btnRoute.classList.add('btn--orange');
    this.$refs.btnRoute.classList.remove('btn--white');

    setTimeout(() => {
      this.$root.$update();
      window.dispatchEvent(new Event('resize'));
    }, 1000);
  }
}
